module.exports = __webpack_public_path__ + "img/google-stadia-06.8a606123.webp";